import { partners, events } from '../../../services/api.admin';
import { fetchTableData, deleteTableData, refresh, resetSelection } from '../tables';
import { MODELS } from '../../../constants/admin/settings';
import { fetchDependencies, fetchModel, submit } from '../forms';
import { fetchDependencies as fetchModalDependencies } from '../modal.forms';
import { stateToApiData, apiDataToState } from '../../../selectors/admin/models/partners';
import { formDataSelector, dependenciesSelector } from '../../../selectors/admin/forms';
import { get, find } from 'lodash';
import { CLEARING_TO_BE_CONFIRMED } from '../../../constants/settings';
import { contextSubjectSelector } from '../../../selectors/admin/context';
import { filtersSelector } from '../../../selectors/admin/tables';
import { VALUE_ALL } from '../../../constants/settings';
import { ADMIN_MODAL_FORMS, ADMIN_FLASH } from '../../../constants/actions';

export function fetchList(contextId, pagination) {
    return (dispatch, getState) => {
        const filters = filtersSelector(getState(), { tableIndex: 0 });
        const apiCall =
            filters.event && filters.event !== VALUE_ALL
                ? () => partners.getForEvent(filters.event, pagination, contextId)
                : contextId
                  ? () => partners.getOrg(contextId, pagination)
                  : () => partners.get(pagination);
        return fetchTableData(apiCall, 'partners', { pagination })(dispatch, getState);
    };
}

export function fetchPartnersFilterDependencies(organizationId) {
    return fetchDependencies([() => events.getOrgAll(organizationId)], { append: true });
}

export function fetchPartnerEvents(eventId, pagination, contextId) {
    return fetchTableData(() => partners.getForEvent(eventId, pagination, contextId), 'partners', {
        pagination,
        transformFunction: (resp, _dispatch, getState) => {
            const clearing = formDataSelector(getState(), { model: MODELS.CONTRACT }).templateClearing || {};
            const dependencies = dependenciesSelector(getState());
            const liveClearing = get(
                find(dependencies.liveStates || [], x => x.id === clearing.liveStateId),
                'name'
            );
            const linearClearing = get(
                find(dependencies.linearStates || [], x => x.id === clearing.linearStateId),
                'name'
            );
            return resp.map(p => {
                p.partnerName = p.name;
                p.liveStateName = liveClearing || CLEARING_TO_BE_CONFIRMED;
                p.linearStateName = linearClearing || CLEARING_TO_BE_CONFIRMED;
                p.comment = clearing.comments || '';
                return p;
            });
        }
    });
}

export function deletePartners() {
    return deleteTableData(partners.delete, MODELS.PARTNER);
}

export function create(data, _modelId, inputData) {
    if (inputData.context) {
        data.organizationIds = [inputData.context];
    }
    return submit(() => partners.create(stateToApiData(data, true)), 'Media partner successfully created.');
}

export function update(data, id, _, onSuccess) {
    return (dispatch, getState) => {
        const context = contextSubjectSelector(getState());
        return submit(() => partners.update(id, stateToApiData(data), context), 'Media partner successfully updated.', {
            beforeDone: (_response, _dispatch, _getState, doneFunction) => {
                onSuccess();
                doneFunction();
            }
        })(dispatch, getState);
    };
}

export function fetchMember(id) {
    return (dispatch, getState) => {
        const context = contextSubjectSelector(getState());
        return fetchModel(() => partners.getMember(id, context), MODELS.PARTNER, {
            transform: apiDataToState
        })(dispatch);
    };
}

export function fetchPartnerContacts(subContextId, pagination, contextId) {
    return fetchTableData(
        contextId
            ? () => partners.getOrgUsers(subContextId, contextId, pagination)
            : () => partners.getUsers(subContextId, pagination),
        'users',
        {
            pagination
        }
    );
}

export function fetchBulkSetEventsDependencies(organizationId) {
    return fetchModalDependencies([() => events.getOrgAll(organizationId)]);
}

export function bulkUpdateEvents(data, partnerIds) {
    return async (dispatch, getState) => {
        dispatch({ type: ADMIN_MODAL_FORMS.SUBMIT });
        try {
            const context = contextSubjectSelector(getState());
            const partnerResponses = await Promise.all(partnerIds.map(id => partners.getMember(id, context)));
            const partnerData = partnerResponses.map(r => r.json || r);
            await Promise.all(
                partnerData.map(partner =>
                    partners.update(partner.id, stateToApiData({ ...partner, eventIds: data.eventIds || [] }), context)
                )
            );
            dispatch({ type: ADMIN_MODAL_FORMS.SUCCESS });
            dispatch(refresh());
            dispatch(resetSelection(0));
            dispatch({
                type: ADMIN_FLASH.OPEN,
                message: `Events updated for ${partnerIds.length} media partner${partnerIds.length === 1 ? '' : 's'}.`
            });
        } catch (error) {
            dispatch({ type: ADMIN_MODAL_FORMS.FAILED, error: error.message });
        }
    };
}
